import footerBar from './FooterBar.vue'
const FooterBar = {
	install: function(Vue) {
		Vue.component('FooterBar', footerBar)
	}
}
export default FooterBar
